export const allPokemonNames = [
	"abomasnow",
	"abra",
	"absol",
	"accelgor",
	"aegislash-shield",
	"aerodactyl",
	"aggron",
	"aipom",
	"alakazam",
	"alomomola",
	"altaria",
	"amaura",
	"ambipom",
	"amoonguss",
	"ampharos",
	"anorith",
	"araquanid",
	"arbok",
	"arcanine",
	"arceus",
	"archen",
	"archeops",
	"ariados",
	"armaldo",
	"aromatisse",
	"aron",
	"articuno",
	"audino",
	"aurorus",
	"avalugg",
	"axew",
	"azelf",
	"azumarill",
	"azurill",
	"bagon",
	"baltoy",
	"banette",
	"barbaracle",
	"barboach",
	"basculin-red-striped",
	"bastiodon",
	"bayleef",
	"beartic",
	"beautifly",
	"beedrill",
	"beheeyem",
	"beldum",
	"bellossom",
	"bellsprout",
	"bergmite",
	"bewear",
	"bibarel",
	"bidoof",
	"binacle",
	"bisharp",
	"blacephalon",
	"blastoise",
	"blaziken",
	"blissey",
	"blitzle",
	"boldore",
	"bonsly",
	"bouffalant",
	"bounsweet",
	"braixen",
	"braviary",
	"breloom",
	"brionne",
	"bronzong",
	"bronzor",
	"bruxish",
	"budew",
	"buizel",
	"bulbasaur",
	"buneary",
	"bunnelby",
	"burmy",
	"butterfree",
	"buzzwole",
	"cacnea",
	"cacturne",
	"camerupt",
	"carbink",
	"carnivine",
	"carracosta",
	"carvanha",
	"cascoon",
	"castform",
	"caterpie",
	"celebi",
	"celesteela",
	"chandelure",
	"chansey",
	"charizard",
	"charjabug",
	"charmander",
	"charmeleon",
	"chatot",
	"cherrim",
	"cherubi",
	"chesnaught",
	"chespin",
	"chikorita",
	"chimchar",
	"chimecho",
	"chinchou",
	"chingling",
	"cinccino",
	"clamperl",
	"clauncher",
	"clawitzer",
	"claydol",
	"clefable",
	"clefairy",
	"cleffa",
	"cloyster",
	"cobalion",
	"cofagrigus",
	"combee",
	"combusken",
	"comfey",
	"conkeldurr",
	"corphish",
	"corsola",
	"cosmoem",
	"cosmog",
	"cottonee",
	"crabominable",
	"crabrawler",
	"cradily",
	"cranidos",
	"crawdaunt",
	"cresselia",
	"croagunk",
	"crobat",
	"croconaw",
	"crustle",
	"cryogonal",
	"cubchoo",
	"cubone",
	"cutiefly",
	"cyndaquil",
	"darkrai",
	"darmanitan-standard",
	"dartrix",
	"darumaka",
	"decidueye",
	"dedenne",
	"deerling",
	"deino",
	"delcatty",
	"delibird",
	"delphox",
	"deoxys-normal",
	"dewgong",
	"dewott",
	"dewpider",
	"dhelmise",
	"dialga",
	"diancie",
	"diggersby",
	"diglett",
	"ditto",
	"dodrio",
	"doduo",
	"donphan",
	"doublade",
	"dragalge",
	"dragonair",
	"dragonite",
	"drampa",
	"drapion",
	"dratini",
	"drifblim",
	"drifloon",
	"drilbur",
	"drowzee",
	"druddigon",
	"ducklett",
	"dugtrio",
	"dunsparce",
	"duosion",
	"durant",
	"dusclops",
	"dusknoir",
	"duskull",
	"dustox",
	"dwebble",
	"eelektrik",
	"eelektross",
	"eevee",
	"ekans",
	"electabuzz",
	"electivire",
	"electrike",
	"electrode",
	"elekid",
	"elgyem",
	"emboar",
	"emolga",
	"empoleon",
	"entei",
	"escavalier",
	"espeon",
	"espurr",
	"excadrill",
	"exeggcute",
	"exeggutor",
	"exploud",
	"farfetchd",
	"fearow",
	"feebas",
	"fennekin",
	"feraligatr",
	"ferroseed",
	"ferrothorn",
	"finneon",
	"flaaffy",
	"flabebe",
	"flareon",
	"fletchinder",
	"fletchling",
	"floatzel",
	"floette",
	"florges",
	"flygon",
	"fomantis",
	"foongus",
	"forretress",
	"fraxure",
	"frillish",
	"froakie",
	"frogadier",
	"froslass",
	"furfrou",
	"furret",
	"gabite",
	"gallade",
	"galvantula",
	"garbodor",
	"garchomp",
	"gardevoir",
	"gastly",
	"gastrodon",
	"genesect",
	"gengar",
	"geodude",
	"gible",
	"gigalith",
	"girafarig",
	"giratina-altered",
	"glaceon",
	"glalie",
	"glameow",
	"gligar",
	"gliscor",
	"gloom",
	"gogoat",
	"golbat",
	"goldeen",
	"golduck",
	"golem",
	"golett",
	"golisopod",
	"golurk",
	"goodra",
	"goomy",
	"gorebyss",
	"gothita",
	"gothitelle",
	"gothorita",
	"gourgeist-average",
	"granbull",
	"graveler",
	"greninja",
	"grimer",
	"grotle",
	"groudon",
	"grovyle",
	"growlithe",
	"grubbin",
	"grumpig",
	"gulpin",
	"gumshoos",
	"gurdurr",
	"guzzlord",
	"gyarados",
	"hakamo-o",
	"happiny",
	"hariyama",
	"haunter",
	"hawlucha",
	"haxorus",
	"heatmor",
	"heatran",
	"heliolisk",
	"helioptile",
	"heracross",
	"herdier",
	"hippopotas",
	"hippowdon",
	"hitmonchan",
	"hitmonlee",
	"hitmontop",
	"ho-oh",
	"honchkrow",
	"honedge",
	"hoopa",
	"hoothoot",
	"hoppip",
	"horsea",
	"houndoom",
	"houndour",
	"huntail",
	"hydreigon",
	"hypno",
	"igglybuff",
	"illumise",
	"incineroar",
	"infernape",
	"inkay",
	"ivysaur",
	"jangmo-o",
	"jellicent",
	"jigglypuff",
	"jirachi",
	"jolteon",
	"joltik",
	"jumpluff",
	"jynx",
	"kabuto",
	"kabutops",
	"kadabra",
	"kakuna",
	"kangaskhan",
	"karrablast",
	"kartana",
	"kecleon",
	"keldeo-ordinary",
	"kingdra",
	"kingler",
	"kirlia",
	"klang",
	"klefki",
	"klink",
	"klinklang",
	"koffing",
	"komala",
	"kommo-o",
	"krabby",
	"kricketot",
	"kricketune",
	"krokorok",
	"krookodile",
	"kyogre",
	"kyurem",
	"lairon",
	"lampent",
	"landorus-incarnate",
	"lanturn",
	"lapras",
	"larvesta",
	"larvitar",
	"latias",
	"latios",
	"leafeon",
	"leavanny",
	"ledian",
	"ledyba",
	"lickilicky",
	"lickitung",
	"liepard",
	"lileep",
	"lilligant",
	"lillipup",
	"linoone",
	"litleo",
	"litten",
	"litwick",
	"lombre",
	"lopunny",
	"lotad",
	"loudred",
	"lucario",
	"ludicolo",
	"lugia",
	"lumineon",
	"lunala",
	"lunatone",
	"lurantis",
	"luvdisc",
	"luxio",
	"luxray",
	"lycanroc-midday",
	"machamp",
	"machoke",
	"machop",
	"magby",
	"magcargo",
	"magearna",
	"magikarp",
	"magmar",
	"magmortar",
	"magnemite",
	"magneton",
	"magnezone",
	"makuhita",
	"malamar",
	"mamoswine",
	"manaphy",
	"mandibuzz",
	"manectric",
	"mankey",
	"mantine",
	"mantyke",
	"maractus",
	"mareanie",
	"mareep",
	"marill",
	"marowak",
	"marshadow",
	"marshtomp",
	"masquerain",
	"mawile",
	"medicham",
	"meditite",
	"meganium",
	"meloetta-aria",
	"meowstic-male",
	"meowth",
	"mesprit",
	"metagross",
	"metang",
	"metapod",
	"mew",
	"mewtwo",
	"mienfoo",
	"mienshao",
	"mightyena",
	"milotic",
	"miltank",
	"mime-jr",
	"mimikyu-disguised",
	"minccino",
	"minior-red-meteor",
	"minun",
	"misdreavus",
	"mismagius",
	"moltres",
	"monferno",
	"morelull",
	"mothim",
	"mr-mime",
	"mudbray",
	"mudkip",
	"mudsdale",
	"muk",
	"munchlax",
	"munna",
	"murkrow",
	"musharna",
	"naganadel",
	"natu",
	"necrozma",
	"nidoking",
	"nidoqueen",
	"nidoran-f",
	"nidoran-m",
	"nidorina",
	"nidorino",
	"nihilego",
	"nincada",
	"ninetales",
	"ninjask",
	"noctowl",
	"noibat",
	"noivern",
	"nosepass",
	"numel",
	"nuzleaf",
	"octillery",
	"oddish",
	"omanyte",
	"omastar",
	"onix",
	"oranguru",
	"oricorio-baile",
	"oshawott",
	"pachirisu",
	"palkia",
	"palossand",
	"palpitoad",
	"pancham",
	"pangoro",
	"panpour",
	"pansage",
	"pansear",
	"paras",
	"parasect",
	"passimian",
	"patrat",
	"pawniard",
	"pelipper",
	"persian",
	"petilil",
	"phanpy",
	"phantump",
	"pheromosa",
	"phione",
	"pichu",
	"pidgeot",
	"pidgeotto",
	"pidgey",
	"pidove",
	"pignite",
	"pikachu",
	"pikipek",
	"piloswine",
	"pineco",
	"pinsir",
	"piplup",
	"plusle",
	"poipole",
	"politoed",
	"poliwag",
	"poliwhirl",
	"poliwrath",
	"ponyta",
	"poochyena",
	"popplio",
	"porygon",
	"porygon-z",
	"porygon2",
	"primarina",
	"primeape",
	"prinplup",
	"probopass",
	"psyduck",
	"pumpkaboo-average",
	"pupitar",
	"purrloin",
	"purugly",
	"pyroar",
	"pyukumuku",
	"quagsire",
	"quilava",
	"quilladin",
	"qwilfish",
	"raichu",
	"raikou",
	"ralts",
	"rampardos",
	"rapidash",
	"raticate",
	"rattata",
	"rayquaza",
	"regice",
	"regigigas",
	"regirock",
	"registeel",
	"relicanth",
	"remoraid",
	"reshiram",
	"reuniclus",
	"rhydon",
	"rhyhorn",
	"rhyperior",
	"ribombee",
	"riolu",
	"rockruff",
	"roggenrola",
	"roselia",
	"roserade",
	"rotom",
	"rowlet",
	"rufflet",
	"sableye",
	"salamence",
	"salandit",
	"salazzle",
	"samurott",
	"sandile",
	"sandshrew",
	"sandslash",
	"sandygast",
	"sawk",
	"sawsbuck",
	"scatterbug",
	"sceptile",
	"scizor",
	"scolipede",
	"scrafty",
	"scraggy",
	"scyther",
	"seadra",
	"seaking",
	"sealeo",
	"seedot",
	"seel",
	"seismitoad",
	"sentret",
	"serperior",
	"servine",
	"seviper",
	"sewaddle",
	"sharpedo",
	"shaymin-land",
	"shedinja",
	"shelgon",
	"shellder",
	"shellos",
	"shelmet",
	"shieldon",
	"shiftry",
	"shiinotic",
	"shinx",
	"shroomish",
	"shuckle",
	"shuppet",
	"sigilyph",
	"silcoon",
	"silvally",
	"simipour",
	"simisage",
	"simisear",
	"skarmory",
	"skiddo",
	"skiploom",
	"skitty",
	"skorupi",
	"skrelp",
	"skuntank",
	"slaking",
	"slakoth",
	"sliggoo",
	"slowbro",
	"slowking",
	"slowpoke",
	"slugma",
	"slurpuff",
	"smeargle",
	"smoochum",
	"sneasel",
	"snivy",
	"snorlax",
	"snorunt",
	"snover",
	"snubbull",
	"solgaleo",
	"solosis",
	"solrock",
	"spearow",
	"spewpa",
	"spheal",
	"spinarak",
	"spinda",
	"spiritomb",
	"spoink",
	"spritzee",
	"squirtle",
	"stakataka",
	"stantler",
	"staraptor",
	"staravia",
	"starly",
	"starmie",
	"staryu",
	"steelix",
	"steenee",
	"stoutland",
	"stufful",
	"stunfisk",
	"stunky",
	"sudowoodo",
	"suicune",
	"sunflora",
	"sunkern",
	"surskit",
	"swablu",
	"swadloon",
	"swalot",
	"swampert",
	"swanna",
	"swellow",
	"swinub",
	"swirlix",
	"swoobat",
	"sylveon",
	"taillow",
	"talonflame",
	"tangela",
	"tangrowth",
	"tapu-bulu",
	"tapu-fini",
	"tapu-koko",
	"tapu-lele",
	"tauros",
	"teddiursa",
	"tentacool",
	"tentacruel",
	"tepig",
	"terrakion",
	"throh",
	"thundurus-incarnate",
	"timburr",
	"tirtouga",
	"togedemaru",
	"togekiss",
	"togepi",
	"togetic",
	"torchic",
	"torkoal",
	"tornadus-incarnate",
	"torracat",
	"torterra",
	"totodile",
	"toucannon",
	"toxapex",
	"toxicroak",
	"tranquill",
	"trapinch",
	"treecko",
	"trevenant",
	"tropius",
	"trubbish",
	"trumbeak",
	"tsareena",
	"turtonator",
	"turtwig",
	"tympole",
	"tynamo",
	"type-null",
	"typhlosion",
	"tyranitar",
	"tyrantrum",
	"tyrogue",
	"tyrunt",
	"umbreon",
	"unfezant",
	"unown",
	"ursaring",
	"uxie",
	"vanillish",
	"vanillite",
	"vanilluxe",
	"vaporeon",
	"venipede",
	"venomoth",
	"venonat",
	"venusaur",
	"vespiquen",
	"vibrava",
	"victini",
	"victreebel",
	"vigoroth",
	"vikavolt",
	"vileplume",
	"virizion",
	"vivillon",
	"volbeat",
	"volcanion",
	"volcarona",
	"voltorb",
	"vullaby",
	"vulpix",
	"wailmer",
	"wailord",
	"walrein",
	"wartortle",
	"watchog",
	"weavile",
	"weedle",
	"weepinbell",
	"weezing",
	"whimsicott",
	"whirlipede",
	"whiscash",
	"whismur",
	"wigglytuff",
	"wimpod",
	"wingull",
	"wishiwashi-solo",
	"wobbuffet",
	"woobat",
	"wooper",
	"wormadam-plant",
	"wurmple",
	"wynaut",
	"xatu",
	"xerneas",
	"xurkitree",
	"yamask",
	"yanma",
	"yanmega",
	"yungoos",
	"yveltal",
	"zangoose",
	"zapdos",
	"zebstrika",
	"zekrom",
	"zeraora",
	"zigzagoon",
	"zoroark",
	"zorua",
	"zubat",
	"zweilous",
	"zygarde"
];

export const pokemonObjects = allPokemonNames.map(name => ({
	name,
	id: name.toLowerCase()
}));
